<template>
  <div class="building-viewer">
    <header class="building-viewer__header">
      <nav>
         <!--<button
          :class="[hover == 'veza-2NP' ? 'hover' : null]"
          @mouseover="hover = 'veza-2NP'"
          @mouseout="hover = null"
          @click="openFloor('veza-2NP')"
        >
          <span v-html="lang === 'sk' ? '2NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Veža' : '2nd floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Tower'"></span>
        </button>
        <button
          :class="[hover == 'veza-3NP' ? 'hover' : null]"
          @mouseover="hover = 'veza-3NP'"
          @mouseout="hover = null"
          @click="openFloor('veza-3NP')"
        >
          <span v-html="lang === 'sk' ? '3NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Veža' : '3rd floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Tower'"></span>
        </button>
        <button
          :class="[hover == 'veza-4NP' ? 'hover' : null]"
          @mouseover="hover = 'veza-4NP'"
          @mouseout="hover = null"
          @click="openFloor('veza-4NP')"
        >
          <span v-html="lang === 'sk' ? '4NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Veža' : '4th floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Tower'"></span>
        </button>
        <button
          :class="[hover == 'veza-6NP' ? 'hover' : null]"
          @mouseover="hover = 'veza-6NP'"
          @mouseout="hover = null"
          @click="openFloor('veza-6NP')"
        >
          <span v-html="lang === 'sk' ? '5/6NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Veža' : '5/6th floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Tower'"></span>
        </button>-->
        <button
          :class="[hover == '3NP' ? 'hover' : null]"
          @mouseover="hover = '3NP'"
          @mouseout="hover = null"
          @click="openFloor('3NP')"
        >
          <span
            v-html="lang === 'sk' ? '3NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Hlavná budova' : '3rd floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Main building'"
          ></span>
        </button>
        <button
          :class="[hover == '4NP' ? 'hover' : null]"
          @mouseover="hover = '4NP'"
          @mouseout="hover = null"
          @click="openFloor('4NP')"
        >
          <span
            v-html="lang === 'sk' ? '4NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Hlavná budova' : '4th floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Main building'"
          ></span>
        </button>
        <button
          :class="[hover == '6NP' ? 'hover' : null]"
          @mouseover="hover = '6NP'"
          @mouseout="hover = null"
          @click="openFloor('6NP')"
        >
          <span
            v-html="lang === 'sk' ? '5/6NP' + (windowTracker.width < 767 ? '<br>' : ', ') + 'Hlavná budova' : '5/6th floor'+ (windowTracker.width < 767 ? '<br>' : ', ') +'Main building'"
          ></span>
        </button>
      </nav>
    </header>
    <div class="building-viewer__select">
      <img :src="imgsrc" ref="plan" />
      <svg ref="overlay" viewBox="0 0 5000 2043">
        <polygon
          class="budova-6NP"
          :class="[hover == '6NP' ? 'hover' : null]"
          @click="openFloor('6NP')"
          @mouseover="hover = '6NP'"
          @mouseout="hover = null"
          points="142.000 1228.000, 712.000 1243.000, 713.000 1156.000, 1249.000 1171.000, 1251.000 1257.000, 2002.000 1283.000, 2029.000 1260.000, 2081.000 1261.000, 2148.000 1230.000, 2580.000 1239.000, 2585.000 1297.000, 3159.000 1311.000, 3363.000 1265.000, 3740.000 1275.000, 3743.000 1160.000, 3766.000 1153.000, 3768.000 1134.000, 3559.000 924.000, 3485.000 949.000, 3484.000 932.000, 3440.000 930.000, 3432.000 932.000, 3432.000 968.000, 3306.000 1012.000, 3306.000 1000.000, 3251.000 999.000, 3246.000 1001.000, 3245.000 1032.000, 3186.000 1054.000, 2910.000 1043.000, 2911.000 990.000, 2892.000 989.000, 2879.000 994.000, 2878.000 1041.000, 2824.000 1039.000, 2824.000 1028.000, 2806.000 1027.000, 2794.000 1033.000, 2794.000 1038.000, 2731.000 1034.000, 2731.000 981.000, 2713.000 980.000, 2700.000 986.000, 2700.000 1033.000, 2652.000 1030.000, 2652.000 1021.000, 2634.000 1021.000, 2624.000 1024.000, 2623.000 1030.000, 2547.000 1027.000, 2372.000 863.000, 2327.000 895.000, 2326.000 874.000, 2278.000 870.000, 2272.000 874.000, 2270.000 938.000, 2231.000 967.000, 2231.000 951.000, 2170.000 948.000, 2168.000 952.000, 2168.000 987.000, 2073.000 1008.000, 1662.000 989.000, 1663.000 933.000, 1641.000 933.000, 1638.000 987.000, 1636.000 987.000, 1636.000 977.000, 1617.000 976.000, 1614.000 981.000, 1614.000 987.000, 1457.000 981.000, 1458.000 923.000, 1439.000 922.000, 1435.000 927.000, 1435.000 968.000, 1425.000 968.000, 1422.000 972.000, 1422.000 979.000, 1248.000 972.000, 985.000 740.000, 961.000 756.000, 949.000 756.000, 949.000 766.000, 771.000 904.000, 716.000 916.000, 717.000 935.000, 711.000 950.000, 358.000 934.000, 358.000 928.000, 350.000 921.000, 329.000 920.000, 329.000 932.000, 307.000 932.000, 307.000 878.000, 296.000 869.000, 275.000 870.000, 274.000 931.000, 237.000 930.000, 160.000 973.000, 159.000 991.000, 170.000 996.000, 223.000 998.000, 223.000 1163.000, 140.000 1161.000"
        />
        <polygon
          class="budova-4NP"
          :class="[hover == '4NP' ? 'hover' : null]"
          @click="openFloor('4NP')"
          @mouseover="hover = '4NP'"
          @mouseout="hover = null"
          points="142.000 1229.000, 140.000 1363.000, 711.000 1374.000, 713.000 1310.000, 1249.000 1325.000, 1249.000 1386.000, 2004.000 1405.000, 2029.000 1389.000, 2082.000 1390.000, 2149.000 1365.000, 2582.000 1374.000, 2584.000 1413.000, 3160.000 1426.000, 3360.000 1391.000, 3740.000 1396.000, 3739.000 1275.000, 3362.000 1265.000, 3159.000 1311.000, 2583.000 1296.000, 2580.000 1238.000, 2149.000 1229.000, 2079.000 1261.000, 2028.000 1260.000, 2002.000 1282.000, 1250.000 1259.000, 1249.000 1171.000, 713.000 1156.000, 711.000 1244.000"
        />
        <polygon
          class="budova-3NP"
          :class="[hover == '3NP' ? 'hover' : null]"
          @click="openFloor('3NP')"
          @mouseover="hover = '3NP'"
          @mouseout="hover = null"
          points="142.000 1500.000, 712.000 1509.000, 713.000 1466.000, 727.000 1468.000, 1248.000 1474.000, 1250.000 1513.000, 2007.000 1526.000, 2053.000 1526.000, 2148.000 1499.000, 2581.000 1506.000, 2584.000 1532.000, 3161.000 1543.000, 3362.000 1516.000, 3740.000 1521.000, 3740.000 1397.000, 3362.000 1391.000, 3161.000 1426.000, 2598.000 1414.000, 2582.000 1414.000, 2582.000 1374.000, 2148.000 1365.000, 2079.000 1391.000, 2031.000 1387.000, 2001.000 1403.000, 1251.000 1385.000, 1250.000 1323.000, 714.000 1309.000, 710.000 1375.000, 140.000 1363.000"
        />
        <!-- Veze -->
        <!--
        <polygon
          class="veza-2NP"
          :class="[hover == 'veza-2NP' ? 'hover' : null]"
          @click="openFloor('veza-2NP')"
          @mouseover="hover = 'veza-2NP'"
          @mouseout="hover = null"
          points="3742.000 1550.000, 3970.000 1532.000, 4052.000 1525.000, 4226.000 1524.000, 4353.000 1526.000, 4579.000 1528.000, 4645.000 1532.000, 4718.000 1538.000, 4717.000 1594.000, 4791.000 1594.000, 4786.000 1643.000, 4054.000 1641.000, 3970.000 1643.000, 3940.000 1631.000, 3935.000 1589.000, 3743.000 1582.000"
        />
        <polygon
          class="veza-3NP"
          :class="[hover == 'veza-3NP' ? 'hover' : null]"
          @click="openFloor('veza-3NP')"
          @mouseover="hover = 'veza-3NP'"
          @mouseout="hover = null"
          points="4054.000 1405.000, 4215.000 1412.000, 4336.000 1412.000, 4546.000 1415.000, 4717.000 1424.000, 4716.000 1477.000, 4790.000 1482.000, 4789.000 1531.000, 4717.000 1535.000, 4052.000 1524.000, 3744.000 1549.000, 3746.000 1440.000"
        />
        <polygon
          class="veza-4NP"
          :class="[hover == 'veza-4NP' ? 'hover' : null]"
          @click="openFloor('veza-4NP')"
          @mouseover="hover = 'veza-4NP'"
          @mouseout="hover = null"
          points="4054.000 1286.000, 4227.000 1288.000, 4582.000 1297.000, 4718.000 1315.000, 4717.000 1366.000, 4789.000 1369.000, 4787.000 1418.000, 4718.000 1423.000, 4349.000 1412.000, 4054.000 1403.000, 3746.000 1438.000, 3743.000 1327.000"
        />
        <polygon
          class="veza-6NP"
          :class="[hover == 'veza-6NP' ? 'hover' : null]"
          @click="openFloor('veza-6NP')"
          @mouseover="hover = 'veza-6NP'"
          @mouseout="hover = null"
          points="3741.000 1160.000, 3768.000 1152.000, 3768.000 1132.000, 3765.000 1089.000, 3720.000 1083.000, 3886.000 1038.000, 4095.000 1043.000, 4146.000 1031.000, 4345.000 1041.000, 4345.000 1059.000, 4532.000 1070.000, 4512.000 1078.000, 4653.000 1084.000, 4601.000 1097.000, 4599.000 1138.000, 4617.000 1142.000, 4644.000 1140.000, 4643.000 1149.000, 4713.000 1152.000, 4714.000 1179.000, 4779.000 1183.000, 4779.000 1178.000, 4791.000 1178.000, 4790.000 1303.000, 4716.000 1314.000, 4578.000 1296.000, 4347.000 1291.000, 4053.000 1287.000, 3743.000 1326.000"
        />
        -->
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters, HTMLBox } from 'utils/misc';
import { wait } from 'utils/timing';
import { AnimationFrame } from 'utils/timing';

import { IMG_URL } from 'src/constants';

export default {
  name: 'building-viewer',
  computed: {
    ...mapGetters({
      slide: ['getSlide', 'setSlide'],
      floor: ['getFloor', 'setFloor'],
      lang: ['getLang'],
    }),
    imgsrc() {
      return require(`../assets/img/homepage.jpg`);
    }
  },
  data() {
    return {
      animationFrame: null,
      hover: null,
      IMG_URL,
    };
  },
  methods: {
    openFloor(floor) {
      this.slide = 2;
      this.floor = floor;

      wait(0).then(() => this.$scrollTo('#floor-viewer', 700));
    }
  },
  created() {
    this.animationFrame = new AnimationFrame(() => {
      if (this.$refs.plan && this.$refs.overlay) {
        const plan = new HTMLBox(this.$refs.plan);
        const overlay = new HTMLBox(this.$refs.overlay);

        overlay.width = plan.width;
        overlay.height = plan.height;
      }
    }).start();
  },
  beforeDestroy() {
    if (this.animationFrame) {
      this.animationFrame.stop();
    }
  }
};
</script>
